export enum EditGroupTab {
  INFOS = 'infos',
  CONFIGS = 'configs',
  REPORT = 'report',
  LINKED_COMPANIES = 'linkedCompanies',
  WHITE_LABEL = 'whiteLabel',
  API = 'api',
}

export enum GroupWhiteLabelTab {
  INFOS = 'infos',
  MOBILE_APP = 'mobileApp',
}

export enum EditGroupIdTab {
  EQUIPMENTS_PER_INSPECTION_ID = 'equipmentsPerInspection',
}

export enum GroupCheckPointTab {
  VIDEO_LICENSE_PLATE_NUMBER = 'videoLicensePlateNumber',
  PHOTO_LICENSE_PLATE_NUMBER = 'photoLicensePlateNumber',
  VIDEO_BACKGROUND_IMAGE = 'videoBackgroundImage',
  PHOTO_BACKGROUND_IMAGE = 'photoBackgroundImage',
  VIDEO_WATERMARK = 'videoWatermark',
  PHOTO_WATERMARK = 'photoWatermark',
}
